// extracted by mini-css-extract-plugin
export default {"Label":"FormFieldLabel_Label__pPd94"};